export default "__VITE_ASSET__8kqdyW4Z__"